import { useEffect, useState } from 'react';
import { DS_BREAKPOINT_NAV } from '@/lib/designTokens';

export function useIsDesktopNav(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.matchMedia(`(min-width: ${DS_BREAKPOINT_NAV}px)`).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${DS_BREAKPOINT_NAV}px)`);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
